import * as React from "react";
import cx from "classnames";

import "./LoadingSpinner.css";

const getIconClasses = (props: LoadingSpinerProps): string =>
  cx("fa", "fa-pulse", "fa-spinner", "loading-spinner__icon", {
    "fa-2x": props.medium,
    "fa-3x": props.large,
  });

interface LoadingSpinerProps {
  medium?: boolean;
  large?: boolean;
}

const LoadingSpinner = (props: LoadingSpinerProps) =>
  <div className="loading-spinner__container">
    <div>
      <i className={getIconClasses(props)} />
    </div>
  </div>;

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.tsx